import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { AssetTypesService } from 'app/_services/asset-types.service';
import { CompetencyTypesService } from 'app/_services/competency-types.service';
import { SiteTypesService } from 'app/_services/site-types.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-asset-types',
  templateUrl: './asset-types.component.html',
})
export class AssetTypesComponent implements OnInit {
  assetTypes: any[];
  selectedAssetType: any = [];

  siteTypes: any[] = [];
  selectedSiteType = { label: 'Select Site Type', value: null };
  errorAlerts;
  role: any;
  routeRole: any;

  // pagination
  pageSizes: any = environment.pageSizes;
  pagination: any;

  createAssetTypeModal = false;
  createAssetTypeForm: FormGroup;

  defaultColors: any[] = [
    { label: '#fff', value: '#fff' },
    { label: '#46d678', value: '#46d678' },
    { label: '#000105', value: '#000105' },
    { label: '#3e6158', value: '#3e6158' },
    { label: '#3f7a89', value: '#3f7a89' },
    { label: '#96c582', value: '#96c582' },
    { label: '#b7d5c4', value: '#b7d5c4' },
    { label: '#bcd6e7', value: '#bcd6e7' },
    { label: '#7c90c1', value: '#7c90c1' },
    { label: '#9d8594', value: '#9d8594' },
    { label: '#dad0d8', value: '#dad0d8' },
    { label: '#4b4fce', value: '#4b4fce' },
    { label: '#4e0a77', value: '#4e0a77' },
    { label: '#a367b5', value: '#a367b5' },
    { label: '#ee3e6d', value: '#ee3e6d' },
    { label: '#d63d62', value: '#d63d62' },
    { label: '#c6a670', value: '#c6a670' },
    { label: '#f46600', value: '#f46600' },
    { label: '#cf0500', value: '#cf0500' },
    { label: '#efabbd', value: '#efabbd' },
    { label: '#8e0622', value: '#8e0622' },
    { label: '#f0b89a', value: '#f0b89a' },
    { label: '#f0ca68', value: '#f0ca68' },
    { label: '#62382f', value: '#62382f' },
    { label: '#c97545', value: '#c97545' },
    { label: '#c1800b', value: '#c1800b' },
  ];

  selectedColor = { label: '#fff', value: '#fff' };

  competencyTypes: any[] = [];
  selectedCompetencyType = { label: 'Select Competency Type', value: null };
  selectedCompetencyTypesArray: any[] = [];
  dropdownSettings = {};

  constructor(
    public router: Router,
    public globals: Globals,
    public assetTypesService: AssetTypesService,
    public fb: FormBuilder,
    public siteTypesService: SiteTypesService,
    public competencyTypeService: CompetencyTypesService
  ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.resetPagination();

    this.createAssetTypeForm = fb.group({
      color: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      siteType: new FormControl('', [Validators.required]),
      compTypes: new FormControl([this.selectedCompetencyTypesArray]),
    });
  }

  ngOnInit() {
    this.getAllAssetTypes(this.pagination);
    this.getAllSiteTypes();
    this.getAllIndustryCompetencyTypes();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'label',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  // Get all asset types
  public getAllAssetTypes(pagination) {
    this.assetTypesService.getAllAssetTypes(pagination).subscribe((data: any) => {
      this.assetTypes = data.body;
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public getAllSiteTypes() {
    this.siteTypesService.getAllSiteTypesNoPagination().subscribe((data: any) => {
      this.siteTypes.push(this.selectedSiteType);
      data.forEach((element) => {
        const item = {
          label: element.name,
          value: element,
        };
        this.siteTypes.push(item);
      });
    });
  }

  public getAllIndustryCompetencyTypes() {
    this.competencyTypeService.getAllCompetencyTypesByType('INDUSTRY').subscribe((data: any) => {
      data.forEach((element) => {
        const item = {
          label: element.value,
          value: element,
        };
        this.competencyTypes.push(item);
      });
    });
  }

  public onSelectedColorChange(event) {
    this.selectedColor = event;
    this.createAssetTypeForm.patchValue({
      color: this.selectedColor.value,
    });
  }

  // Handle Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllAssetTypes(this.pagination);
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.getAllAssetTypes(this.pagination);
  }

  public toggleCreateAssetTypeModal() {
    this.createAssetTypeModal = !this.createAssetTypeModal;
  }

  public onCreateAssetTypeFormSubmit() {
    const values = this.createAssetTypeForm.value;
    const compTypeIds = [];
    console.log("VALUES", values);

    values.compTypes.forEach((element) => {
      compTypeIds.push(element.value.id);
    });
    const body = {
      color: values.color,
      name: values.name,
      competencyTypeIds: compTypeIds,
      siteTypeId: values.siteType.value.id,
    };
    this.assetTypesService.createAssetType(body).subscribe((data: any) => {
      this.selectedColor = { label: '#fff', value: '#fff' };
      this.createAssetTypeForm.reset();
      this.toggleCreateAssetTypeModal();
      this.getAllAssetTypes(this.pagination);
      Swal.fire('Success', 'Asset Type Created!', 'success');
    });
  }
}
